import { SUBMIT_BOOKING_FAILURE, SUBMIT_BOOKING_REQUEST, SUBMIT_BOOKING_RESET, SUBMIT_BOOKING_SUCCESS } from "../../../types/pvs"


const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const submitBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case SUBMIT_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Something went wrong",
      }

    case SUBMIT_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload?.error || "Something went wrong",
        success: false,
        message: "",
      }

    case SUBMIT_BOOKING_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default submitBookingReducer
